<div
    [formGroup]="parentForm"
    class="grid"
>
    <mat-form-field class="full-width">
        <mat-label>{{ "name" | transloco }}</mat-label>
        <input
            matInput
            formControlName="name"
        />
        @if (parentForm.get("name")?.hasError("required")) {
        <mat-error>{{ "name_required" | transloco }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="full-width">
        <mat-label>{{ "url" | transloco }}</mat-label>
        <input
            matInput
            formControlName="url"
            placeholder="https://example.com"
        />
        @if (parentForm.get("url")?.hasError("pattern")) {
        <mat-error>{{ "url_invalid" | transloco }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="full-width">
        <mat-label>{{ "description" | transloco }}</mat-label>
        <input
            matInput
            formControlName="description"
        />
        @if (parentForm.get("description")?.hasError("required")) {
        <mat-error>{{ "description_required" | transloco }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="full-width">
        <mat-label>{{ "authentication" | transloco }}</mat-label>
        <mat-select formControlName="authorization">
            <mat-option value="NoAuthorization">{{ "no_authentication" | transloco }}</mat-option>
            <mat-option value="BasicAuth">{{ "basic_auth" | transloco }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>